import { TemplateRef } from '@angular/core';

import { VCPMMetricMaps } from '@app/core/models/metrics.constants';
import { defaultLayouts, TableLayoutColumn } from '@app/shared/modules/table-layout/models/table-layout.model';

export enum KeyFiguresTab {
  Account = 0,
  PG = 1,
  Campaign = 2,
  Adgroup = 3,
  Criteria = 4,
}

export enum KeyFiguresStatus {
  Loading = 0,
  Results = 1,
  NoResults = 2,
  Error = 3,
}

export const keyFigureTab = {
  [KeyFiguresTab.Account]: 'account',
  [KeyFiguresTab.PG]: 'pg',
  [KeyFiguresTab.Campaign]: 'campaign',
  [KeyFiguresTab.Adgroup]: 'adgroup',
  [KeyFiguresTab.Criteria]: 'criteria',
};

export interface KeyFiguresColumn extends TableLayoutColumn {
  title?: string;
  width: number;
  tooltip?: string;
  summaryTooltip?: string;
  sortable?: boolean;
  sortOrder?: 'ascend' | 'descend' | null;
  sortPriority?: number;
  left?: boolean;
  summaryTmpl?: TemplateRef<any>;
  rowTmpl?: TemplateRef<any>;
  columnTmpl?: TemplateRef<any>;
  isCustom?: boolean;
  align?: 'right' | 'left' | 'center';
  headerInfoTip?: string;
}

const keyFigureWithTooltip = [
  'revenue',
  'cost_revenue_ratio',
  'return_on_investment',
  'profit_gross',
  'profit_net',
  'revenue_per_conversion',
];

export const keyFiguresCustomColumns: Record<string, { width: number; tooltip: boolean; footnote: string }> = {
  ...defaultLayouts.keyFigures.columns.reduce(
    (a, b) => ({
      ...a,
      [b.id]: {
        tooltip: keyFigureWithTooltip.includes(b.id),
        vcpm: VCPMMetricMaps[b.id],
        width: 100,
      },
    }),
    {},
  ),
};

export interface KeyFiguresTabItem {
  id: string;
  title: string;
  info: string;
  disabled: boolean;
  active: boolean;
  tab: KeyFiguresTab;
}

export interface APIforSections {
  chart: string | null;
  table: string | null;
}
